import styled from "styled-components";
import {Button, Table, Modal} from "react-bootstrap";

export const FormDefaultContainer = styled("div")`
  input:not([type="radio"]) {
    width: 200px;
  }
  .fr-box {
    width: 750px;
  }
  .form-group {
    margin-bottom: 15px;
  }
  fieldset {
    margin-bottom: 0;
    padding-bottom: 0;
  }
  .error-detail {
    margin: 0;
    padding: 0;

    > li {
      font-size: 12px;
      list-style: none;
      color: #b20e0e;
      background-color: #f4dbdb;
      width: fit-content;
      padding: 3px 5px;
      margin-top: 4px;
      border-radius: 5px;
    }
  }

  .reminder {
    margin-top: 30px;
    padding: 12px 20px;
    background-color: #fff4e7;
    color: #ff9125;
    width: 100%;
    border-radius: 5px;
    font-weight: 600;
    display: flex;
    justify-content: left;
    margin-bottom: 10px;
  }
  
  .input-group {
     width: 200px;
    
    .input-group-text {
      font-size: .75rem;
      border-right: 0;
      border-radius: 0.25rem 0 0 0.25rem;
    }
  }
`;

export const StyledTable = styled(Table)`
  text-align: center;
  width: 100%;
  font-size: 13px;
  
  thead {
    background-color: #E9ECEF;
    color: #656565;
    text-transform: uppercase;
  }
`;

export const StyledTitle = styled("h3")`
    font-size: 17px;
`;

export const StyledContainer = styled("div")`
    margin-top: 3em;
`;

export const VerticalLine = styled("div")`
  border-left: 2px solid lightgrey;
  width: 0.5px;
  height: 180px;
  position: absolute;
  left: 50%
`;

export const StyledBackButton = styled(Button)`
    background-color: #B3B3B3 !important;
    color: white !important;
`;

export const StyledSpinner = styled.i`
  .fa-spin-custom,
  .glyphicon-spin {
    animation: spin 1000ms infinite linear;
  }
  @keyframes spin {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(359deg);
    }
  }
`;

export const StyledModalHeader = styled(Modal.Header)`
  justify-content: center;
  text-align: center;
`;

export const StyledModalTitle = styled(Modal.Title)`
  color: #656565;
`;

export const StyledModalBody = styled(Modal.Body)`
  justify-content: center;
  text-align: center;
  color: #656565;
`;

export const StyledModalFooter = styled(Modal.Footer)`
  justify-content: center;
  text-align: center;
`;

export const StyledModal = styled(Modal)`
  .modal-content {
    padding: 1rem;
  }
  p {
    margin-bottom: 0;
  }
  .modal-header {
    border-bottom: 0;
  }
  .modal-footer {
    border-top: 0;
  }
`
